import { Component, ChangeDetectionStrategy } from '@angular/core'

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
  title = 'CAHCC'

  onActivate(event: any) {
    window.scroll(0, 0)
  }
}
